import styled, { css } from 'styled-components';

export const Content = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--cp-surface, #fff);
  width: 100%;
  min-height: ${(props) => (props.height ? props.height : '50px')};
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: url(/images/loader.svg) no-repeat 50% 50%;
  }
  ${(props) =>
    (props.theme === 'dark' || props.theme.theme === 'dark') &&
    css`
      /* v1 dark keeps the legacy slab; v2 resolves to the adaptive surface
         (so it is never a black bar in v2 light). */
      background: var(--cp-surface, #393e44);
      &:after {
        background: url(/images/loader-white.svg) no-repeat 50% 50%;
      }
    `}
  ${(props) =>
    props.$absolute &&
    css`
      position: absolute;
    `}
`;
